/* Generated by restful-react */

import React from 'react'
import { Get, GetProps, useGet, UseGetProps } from 'restful-react'

export const SPEC_VERSION = 'v9'
export interface SpotBiddingConfigFilters {
  namespace?: 'spot_control_panel' | 'strike_price_panel'
  configType?: 'GLOBAL' | 'SHIPPER' | 'DEFAULT' | 'BUCKET'
  shipperApplicationId?: number
}

export interface SpotBiddingConfigResponse {
  spotBiddingConfigs?: SpotBiddingConfig[]
}

export interface SpotBiddingConfig {
  id: number
  namespace: 'strike_price_panel' | 'spot_control_panel'
  configType: 'GLOBAL' | 'SHIPPER' | 'DEFAULT' | 'BUCKET'
  modifyPastPickupType?: string
  rules?: SpotBiddingRule[]
}

export interface SpotBiddingRule {
  id: number
  spotBiddingConfigId?: number
  shipperApplicationId?: number | null
  ruleAction: 'APPLY_PREMIUM' | 'DONT_BID'
  isSameDay?: boolean
  isWeekend?: boolean
  spotPremium: {
    premiumType: 'PERCENTAGE'
    amount: number
  }
  geographicCriteria?: {
    criteriaType: 'REGION' | 'STATE' | 'CITY, STATE' | 'DAT MARKET'
    value: string
    isInbound: boolean
  } | null
  laneGeographicCriteria?: {
    pickupType: 'REGION' | 'STATE' | 'CITY, STATE' | 'DAT MARKET'
    deliveryType: 'REGION' | 'STATE' | 'CITY, STATE' | 'DAT MARKET'
    pickupValue: string
    deliveryValue: string
  } | null
  proximalHourCriteria?: {
    rangeStart: number
    rangeEnd: number
  } | null
  countLoadsQuotedCriteria?: {
    pickupType: string
    deliveryType: string
    pickupValue: string
    deliveryValue: string
    rangeStart: number
    rangeEnd?: number
    isSamePickupDelivery?: boolean
    isDifferentPickupDelivery?: boolean
  } | null
  ruleStartTimeCriteria?: {
    rangeStart: string
  } | null
  dateCriteria?: {
    rangeStart: string
    rangeEnd: string
  }
  mileageCriteria?: {
    rangeStart: number
    rangeEnd?: number
  } | null
  appointmentTimeCriteria?: {
    pickupRangeStart: string
    pickupRangeEnd: string
    deliveryRangeStart: string
    deliveryRangeEnd: string
    timezoneOverride?: string
  } | null
  parentEquipmentKey?: string | null
  reason?: string
}

export interface GetSpotBiddingConfigQueryParams {
  /**
   * Filters
   */
  filters?: SpotBiddingConfigFilters
}

export type GetSpotBiddingConfigProps = Omit<
  GetProps<SpotBiddingConfigResponse, unknown, GetSpotBiddingConfigQueryParams, void>,
  'path'
>

/**
 * Get spot bidding config
 */
export const GetSpotBiddingConfig = (props: GetSpotBiddingConfigProps) => (
  <Get<SpotBiddingConfigResponse, unknown, GetSpotBiddingConfigQueryParams, void>
    path='/v9/spot_bidding_configs'
    {...props}
  />
)

export type UseGetSpotBiddingConfigProps = Omit<
  UseGetProps<SpotBiddingConfigResponse, unknown, GetSpotBiddingConfigQueryParams, void>,
  'path'
>

/**
 * Get spot bidding config
 */
export const useGetSpotBiddingConfig = (props: UseGetSpotBiddingConfigProps) =>
  useGet<SpotBiddingConfigResponse, unknown, GetSpotBiddingConfigQueryParams, void>(
    `/v9/spot_bidding_configs`,
    props
  )
